import { Component, inject, input, model, OnInit, output } from '@angular/core';
import { FormRangesParams } from './form-with-ranges.types';
import { FormArray, FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatProgressBar } from "@angular/material/progress-bar";

@Component({
  selector: 'app-form-with-ranges',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatProgressBar
  ],
  templateUrl: './form-with-ranges.component.html',
  styleUrl: './form-with-ranges.component.scss'
})
export class FormWithRangesComponent implements OnInit {
  params = model<Array<FormRangesParams>>([]);
  title = input<string>('');
  isEditEnabled = input<boolean>(true);
  formRangeChanged = output<Array<FormRangesParams>>();

  private fb: FormBuilder = inject(FormBuilder);

  public ageParamsFormGroup = this.fb.group({
    ageParams: this.fb.array([])
  })

  get ageParams(): FormArray {
    return this.ageParamsFormGroup.controls.ageParams as FormArray;
  }

  public ngOnInit() {
    this.params().forEach((formRangeParam: FormRangesParams) => { this.addAgeParam(formRangeParam); });
    this.ageParams.valueChanges.subscribe((formArrayValue: Array<number>) => {
      this.params.set(this.updateParams(formArrayValue));
      this.formRangeChanged.emit(this.params());
    })
  }

  public handleInputEvent(event: Event): void {
    const maxValue = 100;
    const minValue = 0;
    const inputElement: HTMLInputElement = event.target as HTMLInputElement;
    if (+inputElement.value > maxValue) {
      inputElement.value = `${maxValue}`;
    }
    if (+inputElement.value < minValue) {
      inputElement.value = `${minValue}`;
    }
  }

  private addAgeParam(formRangeParam: FormRangesParams): void {
    this.ageParams.push(this.fb.control(formRangeParam.value || '', [
      Validators.min(0),
      Validators.max(100)
    ]));
    if (!this.isEditEnabled) { this.ageParams.disable(); }
  }

  private updateParams(formArrayValue: Array<number>): Array<FormRangesParams> {
    return this.params().map((param: FormRangesParams, index: number) => {
      return {
        ...param,
        value: formArrayValue[index]
      }
    });
  }
}
